'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: none;\n  font-size: ', ';\n  font-weight: 500;\n  padding: 10px 0 0;\n\n  a {\n    color: ', ';\n  }\n\n  > li {\n    display: inline;\n\n    &:not(:last-child)::after {\n      color: ', ';\n      content: \'/\';\n      margin: 0 .5rem;\n    }\n\n    &:last-child a {\n      color: ', ';\n    }\n  }\n\n  @media (min-width: ', ') {\n    display: block;\n  }\n'], ['\n  display: none;\n  font-size: ', ';\n  font-weight: 500;\n  padding: 10px 0 0;\n\n  a {\n    color: ', ';\n  }\n\n  > li {\n    display: inline;\n\n    &:not(:last-child)::after {\n      color: ', ';\n      content: \'/\';\n      margin: 0 .5rem;\n    }\n\n    &:last-child a {\n      color: ', ';\n    }\n  }\n\n  @media (min-width: ', ') {\n    display: block;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BreadCrumbsContainer = _styledComponents2.default.ul(_templateObject, (0, _rem2.default)('12px', _config.typography.baseFontSize), _config.colors.gray, _config.colors.gray, _config.colors.white, _config.breakpoints.m);

var BreadCrumbs = function BreadCrumbs(_ref) {
  var links = _ref.links;

  var linksWithIDs = links.map(function (link, index) {
    return _extends({
      id: index
    }, link);
  });

  var linkList = linksWithIDs.map(function (link) {
    return _react2.default.createElement(
      'li',
      { key: link.id },
      _react2.default.createElement(
        'a',
        { href: link.href },
        link.title
      )
    );
  });

  return _react2.default.createElement(
    BreadCrumbsContainer,
    null,
    linkList
  );
};

BreadCrumbs.displayName = 'BreadCrumbs';

BreadCrumbs.propTypes = {
  links: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

exports.default = BreadCrumbs;
BreadCrumbs.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'BreadCrumbs',
  'props': {
    'links': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'object'
        }
      },
      'required': true,
      'description': ''
    }
  }
};